import React from "react";
import PropTypes from "prop-types";

const TicketItem = ({
  ticketID,
  customer,
  issue,
  status,
  priority,
  time,
  onClick,
  selectedTicket ,
  setUserId
}) => {
  const statusBadge = status ? (
    <span className={`badge ms-2 bg-${status.toLowerCase() ==="pending" ? "light text-warning" : status.toLowerCase() ==="active" ? "primary" : ""}`}>{status ==="PENDING" ? "في الانتظار" : status ==="ACTIVE" ? "نشط" : status}</span>
  ) : null;
  const priorityBadge = priority ? (
    <span className={`badge ms-2 bg-${priority.toLowerCase()}`}>{priority}</span>
  ) : null;

  return (
    <div
      className={`list-group-item list-group-item-action ticket-item mb-1 p-1 ${selectedTicket?.ticketID === ticketID ?"active":""}`}
      onClick={onClick}
      role="button"
    >
      <strong className="text-smoke">{ticketID}</strong>
      <br />
      <div className="fw-bold">{customer} </div>  
      <br />
     
      <small className="text-smoke">{issue}</small>
      {priorityBadge}
      {statusBadge}
      {time && <small className="text-muted float-end">{time}</small>}
    </div>
  );
};



export default TicketItem;